import { inject, Injectable } from '@angular/core';
import { ApiService, Category, Food, Unit } from '@us/web/shared/data-access';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getSearchableText } from '@us/web/shared/utils';
import {Store} from "@ngrx/store";
import {selectEnableShowMenu} from "@us/web/shop/data-access";

@Injectable({
    providedIn: 'root'
})
export class CategoriesService {
    private readonly apiService = inject(ApiService);
    private readonly store = inject(Store);
    private readonly enableShowMenu = this.store.selectSignal(selectEnableShowMenu);

    public getFoodMenu(shopId?: string): Observable<Category[]> {
        const params = shopId ? { shop_id: shopId } : {};
        return this.apiService.get('shop/food-menus', { params }).pipe(
            map(response => {
                const setting_menu =  response.some((item: any) => item.id > 0);
                const categories: Category[] = [];
                const now = new Date();
                const day = now.getUTCDay();
                const time = now.toLocaleTimeString('en-GB', { hour: 'numeric', minute: 'numeric' });
                let data = response.filter((item: any) =>
                    item.apply_dates.includes(day) && item.time_start < time && item.time_end > time
                );
                let enableShowMenu = this.enableShowMenu();
                if (setting_menu) {
                    data = data.filter((item: any) => item.id > 0);
                    if (!data.length) { // trường hợp menu setting bị rỗng
                        data = response.filter((item: any) => item.id === 0);
                        // enableShowMenu = false;
                    }
                }
                for (const item of data.flatMap((e: any) => e.menu_detail) as Food[]) {
                    item.units = item.units.filter((u: Unit) => !u.hidden_unit);
                    if (!item?.units.length) {
                        // eslint-disable-next-line no-continue
                        continue;
                    }

                    item.price = item.units[0].price;
                    item.old_price = item.units[0].old_price;
                    item.discount_percent = item.old_price
                        ? +(((item.old_price - item.price) / item.old_price) * 100).toFixed(2)
                        : item.discount_percent
                            ? item.discount_percent
                            : null;
                    let id = item.category_id;
                    let name = item.category_name;
                    let thumbnail = item.category_thumbnail;
                    // if (enableShowMenu) {
                    //     const menu = data.find((menu:any)=> menu.id === item.menu_id);
                    //     id = item.menu_id;
                    //     name = menu.name;
                    //     thumbnail = menu.thumbnail;
                    // }

                    const index = categories.findIndex(e => e.id === id);
                    if (index === -1) {
                        const value = {
                            id: Number(id),
                            name: name || '',
                            category_thumbnail: thumbnail || '',
                            items: [item],
                            is_show_menu: Boolean(this.enableShowMenu())
                        }
                        categories.push(value);
                    } else {
                        categories[index].items.push(item);
                    }
                    item.search_str = getSearchableText(item.name).toLowerCase();
                }
                console.log(categories);

                return categories;
            })
        );
    }
}
